import React, { useState } from "react";
import { ReactTitle } from "react-meta-tags";
import Tab from "canvas-core-react/lib/Tab";
import Tabs from "canvas-core-react/lib/Tabs";
import { useTranslation } from "react-i18next";
import MainTemplate from "../mainTemplate";
import DashboardLine from "../dashboard/line";
import RelationList from "./RelationList";
import RelationApprovals from "./RelationApprovals";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const Relations = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab ?? 0);

  const handleTabChange = (event) => {
    setActiveTab(event);
  };

  return (
    <MainTemplate className="wrapper-dashboard">
      <ReactTitle title={`Clientes relacionados - Reverse Factoring`} />
      <DashboardLine />
      <Tabs active={activeTab} onClick={(e) => handleTabChange(e)}>
        <Tab label={t("general.tabs.relations")}>
          <RelationList />
        </Tab>
        <Tab label={t("general.tabs.relation_approval")}>
          <RelationApprovals />
        </Tab>
      </Tabs>
    </MainTemplate>
  );
};

export default Relations;
